var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('statistics-card-line',{staticClass:"mb-base",attrs:{"hideChart":"","icon":['fas', 'shopping-cart'],"icon-right":"","statistic":_vm.orderAmount,"statisticTitle":"Openstaande bestellingen"}})}
var staticRenderFns = []

export { render, staticRenderFns }